import { ActionLink } from "@diffex/ui";
import { useEffect } from "react";

import { PublicLayout } from "../components/PublicLayout";
import { loginUrl, safeReturnTo } from "../config";

export function LoginRedirect() {
  const searchParams = new URLSearchParams(window.location.search);
  const returnTo = safeReturnTo(searchParams.get("return_to"));
  const target = loginUrl(returnTo);

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <PublicLayout>
      <p className="eyebrow">Secure sign in</p>
      <h1>Taking you to Diffex sign in</h1>
      <p>If the page does not change, use the secure sign-in link below.</p>
      <ActionLink href={target}>Continue to sign in</ActionLink>
    </PublicLayout>
  );
}
